/**
 * Convert 24h time (HH:MM) to 12h AM/PM format.
 * "09:00" → "9:00 AM", "16:30" → "4:30 PM", "00:00" → "12:00 AM"
 */
export function formatTime(time) {
  if (!time) return '';
  const [h, m] = time.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
}

/**
 * Format a time range: "09:00" + "16:00" → "9:00 AM - 4:00 PM"
 */
export function formatTimeRange(timeIn, timeOut) {
  return `${formatTime(timeIn)} - ${formatTime(timeOut)}`;
}
